/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from "react";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import BookItemCover from "@components/BookItemCover";

const Wrap = styled.div`
  position: relative;
  margin-bottom: 80px;
  &:last-child {
    margin-bottom: 170px;
  }
`;

const LabelBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 358px;
  height: 358px;
  border-radius: 25px;
  background-color: ${(props) => props.color};
  text-align: center;
`;

const Title = styled.div`
  color: #fff;
  font-size: 70px;
`;
const Desc = styled.span`
  position: absolute;
  bottom: 25px;
  font-size: 22px;
  color: #fff;
  opacity: 0.75;
`;
const Grade = styled.span`
  position: absolute;
  right: 20px;
  top: 20px;
  padding: 10px 25px 10px;
  background-color: #fff;
  border-radius: 25px;
  font-size: 30px;
  color: ${(props) => props.color};
`;

const BookContainer = styled.div`
  position: absolute;
  top: 0;
  left: 360px;
  width: 1330px;
`;

const StepBox = ({ category, badge, desc, color, books, id, cName }) => {
  const renderList = useMemo(() => {
    return books.map((book, i) => {
      return (
        <SwiperSlide key={i}>
          <BookItemCover bookData={book} />
        </SwiperSlide>
      );
    });
  }, []);

  return (
    <Wrap id={id} className={cName}>
      <LabelBox color={color}>
        <Grade color={color}>{badge}</Grade>
        <Title dangerouslySetInnerHTML={{ __html: category + "<br>단계" }} />
        <Desc>{desc}</Desc>
      </LabelBox>
      <BookContainer>
        <Swiper
          spaceBetween={15}
          slidesPerView={3.45}
          slidesOffsetAfter={30}
          slidesOffsetBefore={30}
        >
          {renderList}
        </Swiper>
      </BookContainer>
    </Wrap>
  );
};

export default React.memo(StepBox, () => true);
